import {
  APP_VERSION_CHECK_INTERVAL_MS,
  parseAppVersionPayload,
  shouldPromptAppUpdate,
} from '@/shared/lib/appVersion';
import { useEffect, useRef, useState } from 'react';

/**
 * `/version.json`을 주기적으로 조회해 새 배포를 감지한다.
 * 레거시 `_app.js` checkVersion 로직 포팅.
 */
export const useAppVersionCheck = (
  intervalMs = APP_VERSION_CHECK_INTERVAL_MS,
) => {
  const currentVersion = useRef<string | null>(null);
  const [hasUpdate, setHasUpdate] = useState(false);

  useEffect(() => {
    let cancelled = false;

    const checkVersion = async () => {
      try {
        const res = await fetch('/version.json', { cache: 'no-store' });
        if (!res.ok) return;
        const data: unknown = await res.json();
        const nextVersion = parseAppVersionPayload(data);
        if (!nextVersion || cancelled) return;

        if (shouldPromptAppUpdate(currentVersion.current, nextVersion)) {
          setHasUpdate(true);
        }
        currentVersion.current = nextVersion;
      } catch {
        // 네트워크 오류는 무시 (레거시와 동일)
      }
    };

    void checkVersion();
    const timer = setInterval(() => {
      void checkVersion();
    }, intervalMs);

    return () => {
      cancelled = true;
      clearInterval(timer);
    };
  }, [intervalMs]);

  return { hasUpdate };
};
